import styled, {css} from 'styled-components';

export const SignUpMainWrapper = styled.section(
  props => `
        width:50%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        z-index: 1;

        @media only screen and (min-width:320px) and (max-width: 991px){
            width:100%
        }
        @media only screen and (min-width:991px) and (max-width: 1024px){
          width:100%
        }
    `,
);

export const SignUpWhiteOuterWrapper = styled.div(
  props => `
        width:80%;
        margin:0 auto;
        display: flex;

        @media only screen and (min-width:320px) and (max-width: 991px){
            width:100%
        }

        @media only screen and (min-width:991px) and (max-width: 1024px){
          width:100%
        }

        @media only screen and (min-width:1025px) and (max-width: 1300px){
          width:98%;
      }
    `,
);

export const SignUpWhiteInner = styled.div(
  props => `
        width:100%;
        display: flex;
        background-color: ${props.theme.colors.white.base};
        border-radius: ${props.theme.misc.borderRadius.xlarge} ${
    props.theme.misc.borderRadius.xlarge
  } 0 0;
        box-shadow: 0 1px 100px 0 ${props.theme.colors.black.light1};
        padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l30} ${
    props.theme.spacing.large.l40
  } ${props.theme.spacing.large.l30} ;
        min-height: auto;
        flex-direction: column;

        @media only screen and (min-width:320px) and (max-width: 767px){
            height: auto;
            min-height: auto;
            padding: ${props.theme.spacing.large.l20};
            border-radius: ${props.theme.misc.borderRadius.base} ${
    props.theme.misc.borderRadius.base
  } 0 0;
        }
        @media only screen and (min-width:768px) and (max-width: 1024px){
          height: auto;
          min-height: auto;
          padding: ${props.theme.spacing.large.l20};
          border-radius: ${props.theme.misc.borderRadius.base} ${
    props.theme.misc.borderRadius.base
  } 0 0;
        }

        @media only screen and (min-width:1025px) and (max-width: 1300px){
          height: auto;
          min-height: auto;
          padding: ${props.theme.spacing.large.l20};
          border-radius: ${props.theme.misc.borderRadius.base} ${
    props.theme.misc.borderRadius.base
  } 0 0;
        }
        pointer-events: ${props.disabled ? 'none' : ''};
    `,
);

export const SignUpStepWrapper = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        position: relative;
        border-bottom: 1px solid ${props.theme.colors.black.light1};
        padding-bottom: ${props.theme.spacing.large.l15};
    `,
);

export const SignUpStepIconWrap = styled.div(
  props => `
        display: flex;
        padding:${props.theme.spacing.small.s5} ${props.theme.spacing.small.s5} ${
    props.theme.spacing.small.s5
  } ${props.theme.spacing.nospacing};
        pointer-events: ${props.disabled ? 'none' : ''};
    `,
);

export const SignUpStepTextWrap = styled.div(
  props => `
        display: flex;
        padding-left:${props.theme.spacing.large.l15};

    `,
);

export const SignUpStepCounterWrap = styled.div(
  props => `
          display: flex;
          font-size: small;
          font-weight : bold;
          margin-left : auto;
          background: #fee7d7;
          border-radius: 5px;
          color : #f06305;
          justify-content: flex-end

      `,
);

export const SignUpStepCounterWrapInner = styled.div(
  props => `
        display: flex;
        padding : 1rem;
    `,
);

export const SignUpStepBlueText = styled.span(
  props => `
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.blue.dark};
        font-weight: ${props.theme.font.fontWeight.black};
    `,
);

export const SignUpStepNormalText = styled.span(
  props => `
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.black.base};
        padding-left: ${props.theme.spacing.small.s2};
    `,
);

export const SignUpStepIndicator = styled.span(
  props => `
        position: absolute;
        bottom: -0.1rem;;
        left:0;
        height: .2rem;
        background-color: ${props.theme.colors.blue.dark};
        width: 33%;
    `,
);

export const SignUpStepIndicatorTwo = styled.span(
  props => `
        position: absolute;
        bottom: -0.1rem;;
        left:0;
        height: .2rem;
        background-color: ${props.theme.colors.blue.dark};
        width: 66%;
    `,
);

export const SignUpStepIndicatorThree = styled.span(
  props => `
        position: absolute;
        bottom: -0.1rem;;
        left:0;
        height: .2rem;
        background-color: ${props.theme.colors.blue.dark};
        width: 100%;
    `,
);

export const FormMainWrapper = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.nospacing};
    `,
);

export const WelcomeHeadText = styled.h2(
  props => `
        font-size: ${props.theme.font.large.font28};
        color: ${props.theme.colors.blue.dark};
        font-weight: ${props.theme.font.fontWeight.bold};

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.large.font22};
        }
    `,
);

export const HeadSubText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.light8};
        padding-top:${props.theme.spacing.small.s5};
        letter-spacing: ${props.theme.font.letterSpacing.base};

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.large.font14};
        }
    `,
);

export const HeadSubTitleText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.light8};
        padding-top:${props.theme.spacing.small.s5};
        margin-top: ${props.theme.spacing.small.s5};
        letter-spacing: ${props.theme.font.letterSpacing.base};
        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.large.font14};
        }
    `,
);

export const HeadSubTitleTextSpan = styled.span(
  props => `
        background-color: ${props.theme.colors.grey.lighte7};
        padding: ${props.theme.spacing.small.s8};
        display: inline-flex;
    `,
);

export const FormWrapper = styled.div(
  props => `
        width:100%;
        display: flex;
        padding-top:${props.theme.spacing.large.l20};
    `,
);

export const UserInfoForm = styled.form(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
    `,
);

export const InputWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    justify-content: space-between;
    align-itmes: center;
    padding-bottom:${props.theme.spacing.large.l15};
    position: relative;
    opacity: ${props.disabled ? '0.4' : '1'};
    pointer-events: ${props.disabled ? 'none' : ''};

    @media only screen and (min-width:320px) and (max-width: 991px){
        padding-bottom: ${props.theme.spacing.base};
    }
  `,
);

export const CommonInputWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
        position: relative;
    `,
);

export const CommonInput = styled.input(
  props => `
  width: 100%;
  height: 4.2rem;
  border: 1px solid ${props.theme.colors.grey.lightd0};
  background-color: ${props.theme.colors.white.base};
  border-radius: ${props.theme.misc.borderRadius.small};
  font-size: ${props.theme.font.large.font16};
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
  color: ${props.theme.colors.grey.base};
  font-weight: ${props.theme.font.fontWeight.bold};
  position: relative;
  cursor: pointer;
  ::placeholder {
    lin-height: ${props.theme.font.lineHeight.large};
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.grey.lightc5};
    overflow: visible;
  }
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props.theme.font.large.font14};
  }
  opacity: ${props.disabled ? '0.4' : '1'};
  pointer-events: ${props.disabled ? 'none' : ''};
  border-color: ${props.hasError ? props.theme.colors.red.base : ''};
  text-transform: ${props.isPAN ? props.theme.font.textTransform.upper : ''};
`,
);

export const TitleWrapper = styled.div(
  props => `
        width:9.5rem;
        position: relative;
    `,
);

export const FullNameWrapper = styled.div(
  props => `
        width: 90%;
        padding-left: ${props.theme.spacing.base};
    `,
);

export const EmailWrapper = styled.div(
  props => `
        width: 100%;
    `,
);

export const ButtonWrapper = styled.div(
  props => `
        width:100%;
        display: flex;
        padding-top: ${props.theme.spacing.large.l30};
    `,
);

export const SignUpBtn = styled.button(
  props => `
        width:100%;
        display: flex;
        height:4.5rem;
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light2};
        background-image: linear-gradient(92deg, #53b2fe 0%, #065af3 130%);
        text-transform: ${props.theme.font.textTransform.upper};
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        align-items: center;
        justify-content: center;
        border: none;
        cursor: ${props.disabled ? '' : 'pointer'};
        pointer-events: ${props.disabled ? 'none' : ''};
        opacity: ${props.disabled ? 0.3 : 1};
    `,
);

export const SignUpBtnDisabled = styled.button(
  props => `
        width:100%;
        display: flex;
        height:4.5rem;
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light2};
        background-image: linear-gradient(92deg, #53b2fe 0%, #065af3 130%);
        text-transform: ${props.theme.font.textTransform.upper};;
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        align-items: center;
        justify-content: center;
        border: none;
        opacity: 0.6;
        pointer-events: none;
        cursor: pointer;
    `,
);

export const ErrorText = styled.span(
  props => `
        color: ${props.theme.colors.red.base};
        font-size: ${props.theme.font.small.font10};
    `,
);

export const ApiErrorText = styled.span(
  props => `
        color: ${props.theme.colors.red.base};
        font-size: ${props.theme.font.large.font14};
        padding-top: ${props.theme.spacing.base};
        text-align: ${props.theme.font.textAlign.left};
        width: 100%;
    `,
);

export const CommonSelect = styled.select(
  props => `
  width: 100%;
  height: 4.2rem;
  background-color: ${props.theme.colors.white.base};
  display: flex;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.large.l30} ${
    props.theme.spacing.small.s5
  } ${props.theme.spacing.base};
  border: 1px solid ${props.theme.colors.grey.lightd0};
  background-color: ${props.theme.colors.white.base};
  border-radius: ${props.theme.misc.borderRadius.small};
  font-size: ${props.theme.font.large.font14};
  color: ${props.theme.colors.grey.base};
  font-weight: ${props.theme.font.fontWeight.bold};
  background-image: url('https://assets-gos3.goibibo.com/downarrow-1587111682.png');
  background-repeat: no-repeat;
  background-position: 95% 50%;
  background-size: 1.1rem auto;
  cursor: pointer;
  ::-ms-expand {
    display: none;
  }

  @media only screen and (min-width: 320px) and (max-width: 991px) {
    margin-bottom: ${props.theme.spacing.base};
    font-size: ${props.theme.font.large.font14};
  }
  border-color: ${props.hasError ? props.theme.colors.red.base : ''};
`,
);

export const DownIconWrap = styled.div(
  props => `
        position: absolute;
        top: 0.3rem;
        right: -0.6rem;
        transform: translate(-50%);
        background-color: ${props.theme.colors.white.base};
        height: 3.6rem;
        width: 2rem;
        align-items: center;
        justify-content: center;
        display: flex;
    `,
);

export const BlockWrapper = styled.div(
  props => `
    width:100%;
    pointer-events: ${props.disabled ? 'none' : ''};
  `,
);

export const PopOverlay = styled.div(
  props => `
  width: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: ${props.theme.misc.zIndex.xlarge};
  background-color: ${props.theme.colors.black.light5};
  display: flex;
  aling-items: center;
  justify-content: center;
`,
);
